import SEOMeta from "@/components/SEOMeta";
import NavbarNew from "@/components/NavbarNew";
import FooterNew from "@/components/FooterNew";

const LAST_UPDATED = "3 de julho de 2026";

const TLDR = [
  "Coletamos apenas o necessário por finalidade — nenhum formulário pede CPF, CNPJ ou dado sensível.",
  "Não vendemos nem alugamos seus dados pessoais a terceiros para fins de marketing.",
  "Você pode exercer seus direitos da LGPD a qualquer momento em eliveuton.dev@gmail.com.",
];

const TABLE_ROWS: { form: string; data: string; why: string; base: string }[] = [
  {
    form: "Formulário de contato (Home / /contato)",
    data: "Nome, e-mail, telefone (opcional), tipo de projeto, mensagem",
    why: "Responder à solicitação de orçamento ou contato",
    base: "Consentimento (art. 7º, I) e execução de procedimentos preliminares a contrato (art. 7º, V)",
  },
  {
    form: "Depoimento de cliente",
    data: "Nome, cargo/empresa, texto do depoimento, nota",
    why: "Publicar depoimento no site, mediante revisão prévia",
    base: "Consentimento (art. 7º, I)",
  },
  {
    form: "Assinatura de orçamento/contrato",
    data: "Nome, e-mail, assinatura (imagem, digitada ou certificado digital), endereço IP e navegador",
    why: "Formalizar e comprovar o aceite do contrato/orçamento",
    base: "Execução de contrato (art. 7º, V) e cumprimento de obrigação legal (Lei nº 14.063/2020)",
  },
  {
    form: "Pagamento",
    data: "Nome e e-mail, compartilhados com o processador de pagamento",
    why: "Processar cobranças e pagamentos referentes ao serviço contratado",
    base: "Execução de contrato (art. 7º, V)",
  },
];

const sectionTitle = "font-display text-[17px] font-bold tracking-[-.02em] text-foreground";
const sectionBody = "mt-2.5 text-[14.5px] leading-[1.75] text-muted-foreground";
const linkClass = "text-primary underline hover:no-underline";

const PoliticaDePrivacidade = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOMeta
        title="Política de Privacidade"
        description="Saiba como Eliveuton Dev coleta, usa e protege seus dados pessoais, em conformidade com a LGPD (Lei nº 13.709/2018)."
        canonicalUrl="/politica-de-privacidade"
      />
      <NavbarNew />

      <main className="px-6 pb-20 pt-10">
        <div className="mx-auto max-w-[720px]">
          <div className="rounded-[18px] border border-border bg-card p-6 shadow-card sm:p-[36px_40px]">
            <p className="text-xs font-bold uppercase tracking-[.06em] text-muted-foreground">
              Atualizada em {LAST_UPDATED}
            </p>
            <h1 className="mt-2.5 font-display text-[28px] font-bold tracking-[-.03em] text-foreground">
              Política de Privacidade
            </h1>
            <p className="mt-3.5 text-[15px] leading-[1.75] text-muted-foreground">
              Em resumo: eu coleto só o necessário para te atender, não vendo seus dados para
              ninguém e você pode pedir a exclusão a qualquer momento pelo e-mail abaixo.
            </p>

            <div className="mt-6 rounded-[13px] border border-primary bg-accent px-5 py-[18px]">
              <p className="text-[12.5px] font-bold text-primary">O essencial em 3 linhas</p>
              <div className="mt-2.5 flex flex-col gap-2">
                {TLDR.map((line) => (
                  <div key={line} className="flex items-start gap-2.5">
                    <span className="mt-0.5 text-xs font-bold text-primary">•</span>
                    <span className="text-[13.5px] leading-[1.55] text-foreground">{line}</span>
                  </div>
                ))}
              </div>
            </div>

            <section className="mt-7">
              <h2 className={sectionTitle}>1. Quem trata seus dados</h2>
              <p className={sectionBody}>
                Esta Política de Privacidade se aplica ao site{" "}
                <strong className="text-foreground">eliveutonsouza.com</strong>, operado por{" "}
                <strong className="text-foreground">Eliveuton Souza (Eliveuton Dev)</strong>,
                responsável pelo tratamento dos dados pessoais coletados através deste site. Em caso
                de dúvidas, solicitações ou exercício de direitos, entre em contato pelo e-mail{" "}
                <a href="mailto:eliveuton.dev@gmail.com" className={linkClass}>
                  eliveuton.dev@gmail.com
                </a>
                . Este documento segue os princípios da{" "}
                <strong className="text-foreground">
                  Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 — LGPD)
                </strong>
                .
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>2. Quais dados coletamos e por quê</h2>
              <p className={sectionBody}>
                Coletamos apenas os dados necessários para cada finalidade. Não coletamos CPF, CNPJ
                ou dados sensíveis em nenhum formulário do site. A tabela ao final desta página
                detalha, por formulário, o que é coletado, para quê e com qual base legal.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>3. Com quem compartilhamos seus dados</h2>
              <p className={sectionBody}>
                Utilizamos os seguintes fornecedores (operadores de dados) para operar o site:{" "}
                <strong className="text-foreground">Supabase</strong> — banco de dados e
                autenticação, onde ficam armazenados os dados enviados pelos formulários;{" "}
                <strong className="text-foreground">Google Analytics</strong> — mede visitas e uso
                do site de forma agregada (ver seção de Cookies);{" "}
                <strong className="text-foreground">Mercado Pago</strong> — processa pagamentos via
                PIX e cartão de crédito;{" "}
                <strong className="text-foreground">WhatsApp / Meta</strong> — quando você opta por
                iniciar uma conversa pelo botão de WhatsApp do site. Não vendemos nem alugamos seus
                dados pessoais a terceiros para fins de marketing.
              </p>
            </section>

            <section className="mt-7" id="cookies">
              <h2 className={sectionTitle}>4. Cookies e Google Analytics</h2>
              <p className={sectionBody}>
                Este site utiliza o <strong className="text-foreground">Google Analytics</strong> e
                o <strong className="text-foreground">Meta Pixel</strong> para entender como os
                visitantes usam o site (páginas acessadas, tempo de navegação, origem do acesso), o
                que ajuda a melhorar o conteúdo e a experiência oferecida. Essas ferramentas
                utilizam cookies e podem coletar seu endereço IP e informações do
                dispositivo/navegador. Na sua primeira visita, um banner permite{" "}
                <strong className="text-foreground">aceitar ou recusar</strong> o carregamento
                dessas duas ferramentas — se você recusar, nenhuma delas é carregada. Você também
                pode impedir a coleta pelo Google Analytics instalando o{" "}
                <a
                  href="https://tools.google.com/dlpage/gaoptout"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  complemento de desativação do Google Analytics
                </a>{" "}
                no seu navegador, ou ajustando as configurações de cookies/rastreamento do seu
                navegador ou dispositivo.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>5. Por quanto tempo guardamos seus dados</h2>
              <p className={sectionBody}>
                Mantemos os dados pessoais apenas pelo tempo necessário para cumprir a finalidade
                para a qual foram coletados, ou pelo prazo exigido por lei (por exemplo, documentos
                de contratos e comprovantes de pagamento, que podem precisar ser mantidos por
                obrigações fiscais e cíveis). Após esse período, os dados são excluídos ou
                anonimizados.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>6. Seus direitos como titular dos dados</h2>
              <p className={sectionBody}>
                Nos termos do art. 18 da LGPD, você pode solicitar a qualquer momento: confirmação
                da existência de tratamento dos seus dados; acesso aos dados que temos sobre você;
                correção de dados incompletos, inexatos ou desatualizados; anonimização, bloqueio ou
                eliminação de dados desnecessários ou tratados em desconformidade com a lei;
                portabilidade dos dados a outro fornecedor de serviço; eliminação dos dados tratados
                com base no seu consentimento; revogação do consentimento, a qualquer momento; e
                informação sobre com quem compartilhamos seus dados. Para exercer qualquer um desses
                direitos, envie um e-mail para{" "}
                <a href="mailto:eliveuton.dev@gmail.com" className={linkClass}>
                  eliveuton.dev@gmail.com
                </a>
                . Responderemos em prazo razoável.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>7. Segurança</h2>
              <p className={sectionBody}>
                Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso
                não autorizado, perda ou alteração, incluindo conexões criptografadas (HTTPS) e
                controle de acesso ao banco de dados. Nenhum sistema é 100% infalível, mas
                trabalhamos para manter suas informações seguras.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>8. Alterações desta política</h2>
              <p className={sectionBody}>
                Esta política pode ser atualizada periodicamente para refletir mudanças no site ou
                na legislação. A data da última atualização está sempre indicada no topo desta
                página. Este documento tem caráter informativo e não substitui uma análise jurídica
                personalizada. Em caso de dúvida sobre seus direitos, recomenda-se consultar um
                advogado.
              </p>
            </section>

            <div className="mt-5 overflow-x-auto rounded-[14px] border border-border">
              <div className="min-w-[640px]">
                <div className="grid grid-cols-[1.1fr_1.4fr_1.2fr_1.3fr] gap-3 border-b border-border bg-muted px-4 py-3 text-[11px] font-bold uppercase tracking-[.04em] text-muted-foreground">
                  <span>Formulário</span>
                  <span>Dados coletados</span>
                  <span>Finalidade</span>
                  <span>Base legal</span>
                </div>
                {TABLE_ROWS.map((r) => (
                  <div
                    key={r.form}
                    className="grid grid-cols-[1.1fr_1.4fr_1.2fr_1.3fr] gap-3 border-b border-border/60 px-4 py-3.5 text-[12.5px] leading-[1.55] text-muted-foreground last:border-0"
                  >
                    <span className="font-semibold text-foreground">{r.form}</span>
                    <span>{r.data}</span>
                    <span>{r.why}</span>
                    <span>{r.base}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <FooterNew />
    </div>
  );
};

export default PoliticaDePrivacidade;
